

export class Admin_Dashboard_Daily_Present_Absent_Location_Wise implements IAdmin_Dashboard_Daily_Present_Absent_Location_Wise {
    locationName!: string | undefined;
    totalEmployee!: number | undefined;
    totalPresent!: number | undefined;
    totalAbsent!: number | undefined;
    totalLeave!: number | undefined;

    constructor(data?: IAdmin_Dashboard_Daily_Present_Absent_Location_Wise) {
        if (data) {
            for (var property in data) {
                if (data.hasOwnProperty(property))
                    (<any>this)[property] = (<any>data)[property];
            }
        }
    }

    init(_data?: any) {
        if (_data) {
            this.locationName = _data["locationName"];
            this.totalEmployee = _data["totalEmployee"];
            this.totalPresent = _data["totalPresent"];
            this.totalAbsent = _data["totalAbsent"];
            this.totalLeave = _data["totalLeave"];
        }
    }

    static fromJS(data: any): Admin_Dashboard_Daily_Present_Absent_Location_Wise {
        data = typeof data === 'object' ? data : {};
        let result = new Admin_Dashboard_Daily_Present_Absent_Location_Wise();
        result.init(data);
        return result;
    }

    toJSON(data?: any) {
        data = typeof data === 'object' ? data : {};
        data["locationName"] = this.locationName;
        data["totalEmployee"] = this.totalEmployee;
        data["totalPresent"] = this.totalPresent;
        data["totalAbsent"] = this.totalAbsent;
        data["totalLeave"] = this.totalLeave;
        return data; 
    }
}

export interface IAdmin_Dashboard_Daily_Present_Absent_Location_Wise {
    locationName: string | undefined;
    totalEmployee: number | undefined;
    totalPresent: number | undefined;
    totalAbsent: number | undefined;
    totalLeave: number | undefined;
}

